// Hero block JS.
//   1. Seamless marquee loop — duplicates the track children so the CSS
//      translateX(-50%) animation loops without a visible seam.
//   2. Middle-layer slideshow — cross-fades middle-*.png images in a random
//      order. Each mount re-shuffles so the sequence varies per page load.
//   3. Layer fit-box — all artwork layers share a 2560x1370 aspect and use
//      object-fit: contain; we expose CSS vars for the rendered rect so the
//      pinpoint text layers stay locked to the artwork.

const LAYER_RATIO = 2560 / 1370

const shuffle = (arr) => {
    const a = arr.slice()
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[a[i], a[j]] = [a[j], a[i]]
    }
    return a
}

const updateLayerFit = (el) => {
    const cw = el.clientWidth
    const ch = el.clientHeight
    if (!cw || !ch) return
    let w, h
    if (cw / ch > LAYER_RATIO) {
        h = ch; w = ch * LAYER_RATIO
    } else {
        w = cw; h = cw / LAYER_RATIO
    }
    const left = (cw - w) / 2
    const top  = (ch - h) / 2
    el.style.setProperty('--fit-left',   left + 'px')
    el.style.setProperty('--fit-top',    top  + 'px')
    el.style.setProperty('--fit-width',  w    + 'px')
    el.style.setProperty('--fit-height', h    + 'px')
}

const homeHero = {
    init() {
        // 1) Marquee seam
        document.querySelectorAll('.home-hero .marquee-track').forEach((track) => {
            if (track._seamed) return
            const items = Array.from(track.children)
            items.forEach((item) => {
                track.appendChild(item.cloneNode(true))
            })
            track._seamed = true
        })

        // 2) Hero middle-layer cross-fade slideshow
        document.querySelectorAll('[data-hero-slideshow]').forEach((holder) => {
            if (holder._slideshowStarted) return
            const slides = Array.from(holder.querySelectorAll('[data-slide]'))
            if (slides.length < 2) {
                if (slides[0]) slides[0].classList.add('is-active')
                return
            }

            const order = shuffle(slides.map((_, i) => i))
            let idx = 0
            slides[order[idx]].classList.add('is-active')

            setInterval(() => {
                const current = slides[order[idx]]
                idx = (idx + 1) % order.length
                const next = slides[order[idx]]
                next.classList.add('is-active')
                current.classList.remove('is-active')
            }, 3500)

            holder._slideshowStarted = true
        })

        // 3) Layer fit-box vars
        document.querySelectorAll('.home-hero .hero-layers').forEach((el) => {
            if (el._fitBound) return
            el._fitBound = true
            const update = () => updateLayerFit(el)
            update()
            window.addEventListener('resize', update)
        })
    }
}

export default homeHero
